<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<h1 class="my-4">Mes stats</h1>
	<div class="types-container">
		@for(type of types(); track type.ref){
			<a [routerLink]="router.parse('stat-overview', [type.ref])" class="card bg-base-100 shadow-sm type-elment my-2 p-4">
				<img hSkeleton="200px" [src]="type | imgCardType"/>
			</a>
		}	
	</div>
</div>
